import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import axios from 'axios';
import HomePage from './pages/HomePage';
import NotAvailablePage from './pages/NotAvailablePage';
import AboutPage from './pages/AboutPage';
import SimulationsPage from './pages/SimulationsPage';
import ContactPage from './pages/ContactPage';
import TspPage from './models/tsp/TspPage';
import VrpPage from './models/vrp/VrpPage';
import MtoPage from './models/MTO/MtoPage';
import TpPage from './models/tp/TpPage';
import ShortestPathPage from './models/shortest-path/ShortestPathPage';
import ErrorBoundary from './components/ErrorBoundary';
import { TspProvider } from './models/tsp/context/TspContext';
import { VrpProvider } from './models/vrp/context/VrpContext';
import { MtoProvider } from './models/MTO/context/MtoContext';
import { TpProvider } from './models/tp/context/TpContext';

// Hide annoying ResizeObserver errors that don't affect functionality
const suppressResizeObserverErrors = () => {
  const originalConsoleError = console.error;
  console.error = function(msg, ...args) {
    if (typeof msg === 'string' && (
      msg.includes('ResizeObserver') || 
      msg.includes('vis-network')
    )) {
      return;
    }
    originalConsoleError.apply(console, [msg, ...args]);
  };
};

// Setup axios to handle network errors nicely
const setupAxiosInterceptors = () => {
  axios.interceptors.request.use(
    config => config,
    error => Promise.reject(error)
  );

  axios.interceptors.response.use(
    response => response,
    error => {
      if (error.code === 'ERR_NETWORK' || !error.response) {
        console.error('Network connection error, please check if the API server is running');
      }
      
      if (error.name === 'AbortError' || error.code === 'ERR_CANCELED') {
        return Promise.reject(error);
      }
      
      return Promise.reject(error);
    }
  );
};

// Setup global configs
suppressResizeObserverErrors();
setupAxiosInterceptors();

// Route wrappers with context providers
const TspRoute = () => (
  <TspProvider>
    <TspPage />
  </TspProvider>
);

const VrpRoute = () => (
  <VrpProvider>
    <VrpPage />
  </VrpProvider>
);

const TpRoute = () => (
  <TpProvider>
    <TpPage />
  </TpProvider>
);

const MtoRoute = () => (
  <MtoProvider>
    <MtoPage />
  </MtoProvider>
);

// Main app component
function App() {
  return (
    <ErrorBoundary>
      <Router>
        <Routes>
          <Route path="/" element={<HomePage/>} />
          <Route path="/vrp" element={<VrpRoute/>} />
          <Route path="/tsp" element={<TspRoute/>} />
          <Route path="/tp" element={<TpRoute/>} />
          <Route path="/multi-modal" element={<MtoRoute/>} />
          <Route path="/shortest-path" element={
            <ErrorBoundary>
              <ShortestPathPage/>
            </ErrorBoundary>
          } />
          <Route path="/spp" element={
            <ErrorBoundary>
              <ShortestPathPage/>
            </ErrorBoundary>
          } />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/login" element={<NotAvailablePage title="Login/Sign Up" message="User authentication coming soon." />} />
          <Route path="/simulations" element={<SimulationsPage />} />
          <Route path="*" element={<NotAvailablePage/>} />
        </Routes>
      </Router>
    </ErrorBoundary>
  );
}

export default App;
